/* Web Audio -synteesi, ei äänitiedostoja. Portattu suoraan pelin aiemmasta
 * single-file-versiosta (ks. index.html.v1-single-file.bak) — nämä eivät
 * riippuneet ortografisesta kamerasta, joten siirtyivät sellaisenaan. */

let actx = null, masterGain = null, kohinaBuffer = null;

export function alustaAudio() {
  if (!actx) {
    try { actx = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) { return; }
    masterGain = actx.createGain();
    masterGain.gain.value = 0.8;
    const lampo = actx.createBiquadFilter();
    lampo.type = 'lowpass';
    lampo.frequency.value = 5200;
    masterGain.connect(lampo).connect(actx.destination);
    kohinaBuffer = actx.createBuffer(1, Math.floor(actx.sampleRate * 0.6), actx.sampleRate);
    const data = kohinaBuffer.getChannelData(0);
    for (let i = 0; i < data.length; i++) data[i] = Math.random() * 2 - 1;
  }
  if (actx.state === 'suspended') actx.resume();
}

export function piippaa(taajuus = 660, kesto = 0.08, tyyppi = 'square', voim = 0.15) {
  if (!actx || actx.state !== 'running') return;
  const o = actx.createOscillator();
  const g = actx.createGain();
  o.type = tyyppi;
  o.frequency.value = taajuus;
  g.gain.setValueAtTime(voim, actx.currentTime);
  g.gain.exponentialRampToValueAtTime(0.001, actx.currentTime + kesto);
  o.connect(g).connect(masterGain);
  o.start();
  o.stop(actx.currentTime + kesto);
}

export function vesiAani() {
  if (!actx || actx.state !== 'running') return;
  const nyt = actx.currentTime;
  const lahde = actx.createBufferSource();
  lahde.buffer = kohinaBuffer;
  const suodin = actx.createBiquadFilter();
  suodin.type = 'bandpass'; suodin.frequency.value = 2200; suodin.Q.value = 0.7;
  const g = actx.createGain();
  g.gain.setValueAtTime(0.22, nyt);
  g.gain.exponentialRampToValueAtTime(0.001, nyt + 0.22);
  lahde.connect(suodin).connect(g).connect(masterGain);
  lahde.start(nyt, 0, 0.22);
  piippaa(760, 0.14, 'sine', 0.1);
}

export function rikkaruohoAani() {
  if (!actx || actx.state !== 'running') return;
  const nyt = actx.currentTime;
  const lahde = actx.createBufferSource();
  lahde.buffer = kohinaBuffer;
  const suodin = actx.createBiquadFilter();
  suodin.type = 'highpass'; suodin.frequency.value = 1600;
  const g = actx.createGain();
  g.gain.setValueAtTime(0.16, nyt);
  g.gain.exponentialRampToValueAtTime(0.001, nyt + 0.12);
  lahde.connect(suodin).connect(g).connect(masterGain);
  lahde.start(nyt, 0, 0.12);

  const o = actx.createOscillator();
  const og = actx.createGain();
  o.type = 'triangle';
  o.frequency.setValueAtTime(300, nyt);
  o.frequency.exponentialRampToValueAtTime(140, nyt + 0.15);
  og.gain.setValueAtTime(0.14, nyt);
  og.gain.exponentialRampToValueAtTime(0.001, nyt + 0.16);
  o.connect(og).connect(masterGain);
  o.start(nyt); o.stop(nyt + 0.17);
}

export function tuholainenAani() {
  if (!actx || actx.state !== 'running') return;
  const nyt = actx.currentTime;
  const o = actx.createOscillator();
  const g = actx.createGain();
  o.type = 'square';
  o.frequency.setValueAtTime(260, nyt);
  o.frequency.exponentialRampToValueAtTime(55, nyt + 0.18);
  g.gain.setValueAtTime(0.16, nyt);
  g.gain.exponentialRampToValueAtTime(0.001, nyt + 0.2);
  o.connect(g).connect(masterGain);
  o.start(nyt); o.stop(nyt + 0.2);
}

export const AANIFUNKTIOT = { kuiva: vesiAani, rikkaruoho: rikkaruohoAani, tuholainen: tuholainenAani };

export function kuolemaAani() {
  if (!actx || actx.state !== 'running') return;
  const nyt = actx.currentTime;
  [260, 200, 150].forEach((f, i) => {
    const o = actx.createOscillator(), g = actx.createGain();
    o.type = 'triangle'; o.frequency.value = f;
    const alku = nyt + i * 0.09;
    g.gain.setValueAtTime(0.001, alku);
    g.gain.linearRampToValueAtTime(0.15, alku + 0.02);
    g.gain.exponentialRampToValueAtTime(0.001, alku + 0.22);
    o.connect(g).connect(masterGain);
    o.start(alku); o.stop(alku + 0.24);
  });
}

export function loppuAani() {
  if (!actx || actx.state !== 'running') return;
  const nyt = actx.currentTime;
  [300, 220, 160, 110].forEach((f, i) => {
    const o = actx.createOscillator(), g = actx.createGain();
    o.type = 'triangle'; o.frequency.value = f;
    const alku = nyt + i * 0.15;
    g.gain.setValueAtTime(0.001, alku);
    g.gain.linearRampToValueAtTime(0.16, alku + 0.02);
    g.gain.exponentialRampToValueAtTime(0.001, alku + 0.32);
    o.connect(g).connect(masterGain);
    o.start(alku); o.stop(alku + 0.34);
  });
}

let ambientNodes = null;
export function kaynnistaAmbient() {
  if (!actx || actx.state !== 'running' || ambientNodes) return;
  const g = actx.createGain();
  g.gain.value = 0.001;
  g.gain.linearRampToValueAtTime(0.035, actx.currentTime + 1.2);
  const suodin = actx.createBiquadFilter();
  suodin.type = 'lowpass'; suodin.frequency.value = 900;
  const o1 = actx.createOscillator(); o1.type = 'sine'; o1.frequency.value = 110;
  const o2 = actx.createOscillator(); o2.type = 'sine'; o2.frequency.value = 165;
  o1.connect(suodin); o2.connect(suodin); suodin.connect(g).connect(masterGain);
  o1.start(); o2.start();
  ambientNodes = { g, o1, o2 };
}
export function pysaytaAmbient() {
  if (!ambientNodes) return;
  const nyt = actx.currentTime;
  ambientNodes.g.gain.exponentialRampToValueAtTime(0.0001, nyt + 0.6);
  const nodes = ambientNodes;
  setTimeout(() => { nodes.o1.stop(); nodes.o2.stop(); }, 700);
  ambientNodes = null;
}
